// src/lib/components/atoms/GenericDisplayAtom/GenericDisplayAtom.tsx
import React from 'react';
import './GenericDisplayAtom.scss';

export interface DisplayLine {
  /** Optional bold label before the value */
  label?: string;
  /** Primitive value to show (string|number|boolean) */
  value: string | number | boolean;
  /** Optional extra class for this line */
  className?: string;
}

export type GenericDisplayVariant =
  | 'full'
  | 'compact'
  | 'inline'
  | 'highlight'
  | 'minimal';

export interface GenericDisplayAtomProps {
  /** The first (main) display value */
  main: string | number | boolean;
  /** Additional lines (e.g. metadata, labels, etc.) */
  meta?: DisplayLine[];
  /** BEM modifier, e.g. 'compact', 'inline', 'highlight', 'minimal' */
  variant?: GenericDisplayVariant;
  /** Extra wrapper className */
  className?: string;
}

export const GenericDisplayAtom: React.FC<GenericDisplayAtomProps> = ({
  main,
  meta = [],
  variant = 'full',
  className = '',
}) => {
  const base = 'generic-display-atom';
  const mods = `${base}--${variant}`;

  return (
    <div className={[base, mods, className].join(' ')}>
      <div className={`${base}__content`}>
        <p className={`${base}__main`}>{String(main)}</p>
        {meta.map((line) => {
          const key = `${line.label ?? ''}-${line.value}-${line.className ?? ''}`;
          return (
            <p
              key={key}
              className={[`${base}__meta`, line.className || ''].join(' ')}
            >
              {line.label != null && (
                <span className={`${base}__label`}>{line.label}</span>
              )}
              {String(line.value)}
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default GenericDisplayAtom;
